import styled, { css } from "styled-components";
import icoInfo from './images/ico-info.svg';
import { colors } from './../../variables';
import { RouteComponentProps, withRouter } from "react-router-dom";

export const IconLanding = styled.div`
  text-align: center;
  img{
    width: 120px;
    height: auto;
    @media (max-width: 991px){
      
    }
  }
`;

export const Catchline = styled.h1`
  position: relative;
  font-size: 32px;
  line-height: 32px;
  color: #4a4a4a;
  @media (max-width: 991px){
    position: relative;
    text-align: center;
    left: inherit;
    font-size: 26px;
    line-height: 28px;
    color: #4a4a4a;
    margin-top: 0px;
    position: relative;
    display: block;
  }
`;

export const LandingWrapper = styled.div`
  width: 450px;
  background-color: #fff;
  border-radius: 0px;
  color: #4a4a4a;
  position: relative;
  margin-top: 60px;
  z-index: 30;
  left: 50%;
  margin-left: -225px;
  @media (max-width: 991px){
    position: relative;
    margin-left: inherit;
    margin: 0 auto;
    margin-top: 80px;
    margin-bottom: 20px;
    background-color: #fff;
    left: inherit;
    width: 90%;
    
    button{
      background-color: #fff;
      color: #8960E8;
    }
  }
`;

export const Sep = styled.div`
  height: 1px;
  width: 20%;
  margin: 0px auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #ccc;
`;

export const LandingContent = styled.div`
  padding: 40px 40px;
  color: #4a4a4a;
  font-weight: normal;
  text-align: center;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;

export const LandingTitle = styled.div`
  font-weight: 400;
  margin-top: 20px;
  font-size: 14px;
  color: #4a4a4a;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;

export const LandingMessage = styled.div`
  font-weight: 300;
  margin-top: 20px;
  font-size: 16px;
  color: #4a4a4a;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;

export const LandingFormContainer = styled.div`
  
`;


export const LandingForm = styled.div`
  padding: 40px;
  color: #4a4a4a;
  padding-bottom: 20px;
  @media (max-width: 991px){
    button{
      width: 100%;
    }
  }
  @media (max-width: 767px){
      padding: 20px;
    }
  h3{
    margin-bottom: 20px;
  }
`;

export const ButtonGroup = styled.div`
  text-align: center;
    button{
      padding: 15px 20px;
      font-size: 12px;
      margin: 0px;
      margin-top: 10px;
      width: 100%;
      letter-spacing: 2px;
      font-family: 'EB Garamond';
      text-align: center;
      font-weight: 400;
      background-color: #9b5249;
      color: #fff;
      justify-content: center;
      @media (max-width: 767px){
        flex: inherit;
        font-size: 12px;
        line-height: inherit;
      }
  }
`;

export const InputGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
export const InputLabel = styled.div`
  position: absolute;
  left: 20px;
  top: -10px;
  padding: 0px 10px;
  font-size: 14px;
  z-index: 20;
  background-color: #fff;
`;

export const InputField = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 18px 20px;
  border-radius: 0px;
  height: 14px;
  width: 100%;
  display: block;
  position: relative;
  font-size: 16px;
  background-color: #fff;
  border: 1px solid #4a4a4a;
  color: #4a4a4a;
  &::placeholder {
    color: #909090;
    @media (max-width: 991px){
      color: #909090;
    }
  }
  &.error{
    border: 1px solid red;
  }
  span{
    position: absolute;
    right: 5px;
  }
  &:focus{
    outline: inherit;
  }
`;
export const InputInfoIcon = styled.div<{active?: boolean}>`
  position: absolute;
  right: 20px;
  top: 16px;
  background-image: url(${icoInfo});
  background-size: 20px auto;
  background-position: center center;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  opacity: 0.4;
  @media (max-width: 991px){
    filter: invert(1);
    opacity: 1;
  }
  cursor: pointer;
  ${props => props.active && css`
    opacity: 1;
  `}
`;
export const InputInfo = styled.div<{active?: boolean}>`
  position: absolute;
  right: 0px;
  bottom: -70px;
  background-color: #909090;
  width: 200px;
  padding: 20px;
  border-radius: 10px;
  font-size: 11px;
  font-style: italic;
  color: #4a4a4a;
  z-index: 9999;
  -webkit-box-shadow: 0px 0px 56px 8px rgba(0,0,0,0.25);
  -moz-box-shadow: 0px 0px 56px 8px rgba(0,0,0,0.25);
  box-shadow: 0px 0px 56px 8px rgba(0,0,0,0.25);
  
  &:after{
    width: 0;
    height: 0;
    content: '';
    position: absolute;
    top: -10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 15px solid #909090;
    right: 17px;
    margin-left: 15px;
  }
  display: none;
  ${props => props.active && css`
    display: block;
  `}
`;